export const categoryTypes = {
  allMedia: 'allMedia',
};
